module.exports = __WEBPACK_EXTERNAL_MODULE_35__;


//////////////////
// WEBPACK FOOTER
// external "factorial-form"
// module id = 35
// module chunks = 0